const dashboardPaths = {
    root: '/dashboard',
  };
  
  export default dashboardPaths;
  